<template>
    <u-btn-arrow-flat-tile v-bind="$attrs" @click="$emit('click')">
        <icon-arrow-primary v-bind="{ direction }" />
    </u-btn-arrow-flat-tile>
</template>

<script>
import IconArrowPrimary from "@/components/publish/parents/icons/icon-arrow-primary.vue";
import UBtnArrowFlatTile from "@/components/publish/styles/buttons/u-btn-arrow-flat-tile.vue";

export default {
    props: {
        direction: { type: String, default: "right" },
    },
    components: {
        IconArrowPrimary,
        UBtnArrowFlatTile,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
